/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { NotebookPen } from 'lucide-react';
import { marked } from 'marked';
import { ChatToolItemProps } from '../types';

export const OpenInWriterToolbarItem: React.FC<ChatToolItemProps> = ({
  disabled,
  messages,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Tooltip title={t('chat.openInWriter')} placement="top" arrow>
      <span>
        <IconButton
          color="primary"
          onClick={async () => {
            const lastAiMessage = messages
              .filter((msg) => msg.sender === 'ai' && msg.status === 'sent')
              .pop();
            if (lastAiMessage) {
              navigate('/articles/new', {
                state: {
                  content: await marked(
                    lastAiMessage.content.split('</think>').pop(),
                  ),
                },
              });
            }
          }}
          disabled={
            disabled ||
            !messages.some(
              (msg) => msg.sender === 'ai' && msg.status === 'sent',
            )
          }
          size="small"
        >
          <NotebookPen />
        </IconButton>
      </span>
    </Tooltip>
  );
};
